    <div class="preloaded_files">

      <mat-card *ngFor="let example of local_examples">
        <mat-card-title>{{example.title}}

        </mat-card-title>
       <img mat-card-image src="/assets/example_img/{{example.id}}.{{example.ext}}" alt="Screenshot of the File Contents">
          <mat-card-content >
            <p>
              {{example.desc}}
            </p>
          </mat-card-content>
        <mat-card-actions>
          <button (click)="loadExample(example.id)" mat-raised-button color="primary"> Open </button>
        </mat-card-actions>
      </mat-card>

      </div>
     

